import { render, staticRenderFns } from "./TwProcessGroupListPreviewIpDnTable.vue?vue&type=template&id=abda06ba&scoped=true&"
import script from "./TwProcessGroupListPreviewIpDnTable.vue?vue&type=script&lang=js&"
export * from "./TwProcessGroupListPreviewIpDnTable.vue?vue&type=script&lang=js&"
import style0 from "./TwProcessGroupListPreviewIpDnTable.vue?vue&type=style&index=0&id=abda06ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abda06ba",
  null
  
)

export default component.exports